import { Component, Input } from "@angular/core";

@Component({
  selector: "app-not-found",
  templateUrl: "not-found.html",
})
export class NotFoundComponent {

  @Input("list") public list: any[];

}



// WEBPACK FOOTER //
// ./src/components/not-found/not-found.ts